// Take control of scroll position ourselves - otherwise the browser's own
// scroll restoration on back navigation can fire after our restore logic
// runs below and snap the page back to wherever it recorded, undoing it.
if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual';
}

document.addEventListener('DOMContentLoaded', function() {

    const load_btn = document.querySelector(".custom-filter-load-more");
    const infinite_scroll = document.querySelector('.infinite-scroll');
    let products_on_page = document.querySelector('.collection-grid');
    let url = products_on_page.getAttribute('data-next-url');
    const spinner = document.querySelector('.load-more-spinner');

    // Guards against the infinite-scroll observer and the return-state
    // restore loop both triggering a fetch for the same page at once.
    let load_more_in_flight = null;

    const load_more = () => {
        if (load_more_in_flight) {
            return load_more_in_flight;
        }

        spinner.classList.add("show");

        load_more_in_flight = fetch(url)
            .then(function (response) {
                if (response.ok) {
                    return response.text();
                } else {
                    throw new Error('Network response was not ok.');
                }
            })
            .then(function (data) {
                const html = document.createElement('div');
                html.innerHTML = data;

                let links = html.querySelector('.pagination-links').innerHTML;
                document.querySelector('.pagination-links').innerHTML = links;

                let new_grid = html.querySelector('.collection-grid');
                url = new_grid.getAttribute('data-next-url');
                if (url === '') {
                    load_btn.style.display = 'none';
                }
                let new_products = new_grid.querySelectorAll(".product-card, .collection-grid-cta");

                new_products.forEach(new_prod => {
                    products_on_page.append(new_prod);
                });
            })
            .catch(function (error) {
                window.log(error);
            })
            .then(function () {
                // Swiper/reviews init are visual enhancements - if either throws,
                // it must not leave the load-more spinner stuck permanently.
                try {
                    initializeProductCardSwipers();
                } catch (error) {
                    window.log(error);
                }

                try {
                    initRatingSnippet();
                } catch (error) {
                    window.log(error);
                }

                spinner.classList.remove("show");
                load_more_in_flight = null;
            });

        return load_more_in_flight;
    }

    // Remember the last product card clicked on and scroll to it when returning to page
    const RETURN_STATE_KEY = 'ktCollectionReturnState';
    const current_collection_url = window.location.pathname + window.location.search;

    products_on_page.addEventListener('click', function (e) {
        const card = e.target.closest('.product-card');
        if (!card) return;

        const productId = card.getAttribute('data-product-id');
        if (!productId) return;

        sessionStorage.setItem(RETURN_STATE_KEY, JSON.stringify({
            collectionUrl: current_collection_url,
            productId: productId,
            scrollY: window.scrollY
        }));
    });

    const restore_return_state = () => {
        const stored = sessionStorage.getItem(RETURN_STATE_KEY);
        if (!stored) return;

        let state;
        try {
            state = JSON.parse(stored);
        } catch (e) {
            return;
        }

        if (!state || state.collectionUrl !== current_collection_url) {
            return;
        }

        sessionStorage.removeItem(RETURN_STATE_KEY);

        // The theme sets `scroll-behavior: smooth` globally, which turns
        // scrollIntoView/scrollTo into an animation. Lazy-loaded images and
        // the Swiper/reviews re-init that follow keep shifting layout right
        // as that animation runs, which can cancel it before it visibly
        // moves anywhere. Force instant scrolling here by overriding it
        // with an inline style, which takes precedence over the CSS rule.
        const previous_scroll_behavior = document.documentElement.style.scrollBehavior;
        document.documentElement.style.scrollBehavior = 'auto';

        const restore_scroll_behavior = () => {
            document.documentElement.style.scrollBehavior = previous_scroll_behavior;
        };

        const scroll_to_product = () => {
            const card = products_on_page.querySelector('.product-card[data-product-id="' + state.productId + '"]');
            if (card) {
                card.scrollIntoView({ block: 'center' });
                restore_scroll_behavior();
                return true;
            }
            return false;
        };

        if (scroll_to_product()) return;

        const load_until_found = () => {
            if (url === '') {
                // Ran out of pages to load fallback
                window.scrollTo(0, state.scrollY);
                restore_scroll_behavior();
                return;
            }

            load_more().then(function () {
                if (!scroll_to_product()) {
                    load_until_found();
                }
            });
        };

        load_until_found();
    };

    restore_return_state();

    // On a back-forward-cache restore (common on mobile Safari), the page's
    // JS context is frozen and resumed as-is - DOMContentLoaded never fires
    // again, so the call above alone won't run for a cached "back" nav.
    // Listeners registered before the freeze do still fire, so re-run the
    // restore here too via the persisted pageshow event.
    window.addEventListener('pageshow', function (event) {
        if (event.persisted) {
            restore_return_state();
        }
    });

    if (load_btn) {
        if (url === '') {
            load_btn.style.display = 'none';
        }

        load_btn.addEventListener("click", ()=> {
            load_more();
        });

        if (infinite_scroll) {
            // Intersection Observer
            const options = {
                root: null,
                rootMargin: '300px',
                threshold: 0.1
            }

            const observer = new IntersectionObserver((entries, observer) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        load_more();
                    }
                });
            }, options);

            observer.observe(infinite_scroll);
        }


    }

    const rangeInput = document.querySelectorAll(".range-input input");
    if (rangeInput) {
        const priceInput = document.querySelectorAll(".price-input-show");
        const range = document.querySelector(".slider .progress");
        const minFilterInput = document.querySelector('.min-price-filter');
        const maxFilterInput = document.querySelector('.max-price-filter');
        let priceGap = 1;

        if (maxFilterInput && minFilterInput) {

            if (maxFilterInput.value != "") {
                range.style.left = ((minFilterInput.value / rangeInput[0].max) * 100) + "%";
                range.style.right = 100 - (maxFilterInput.value / rangeInput[1].max) * 100 + "%";
                rangeInput[0].value = minFilterInput.value;
                rangeInput[1].value = maxFilterInput.value;
                priceInput[0].innerHTML = minFilterInput.value;
                priceInput[1].innerHTML = maxFilterInput.value;
            }

            priceInput.forEach(input => {
                input.addEventListener("input", e => {
                    let minPrice = parseInt(priceInput[0].innerHTML);
                    let maxPrice = parseInt(priceInput[1].innerHTML);

                    if ((maxPrice - minPrice >= priceGap) && maxPrice <= rangeInput[1].max) {
                        if (e.target.className === "input-min") {
                            rangeInput[0].value = minPrice;
                            rangeInput[0].setAttribute("data-term", minPrice);
                            range.style.left = ((minPrice / rangeInput[0].max) * 100) + "%";
                        } else {
                            rangeInput[1].value = maxPrice;
                            maxFilterInput.value = maxVal;
                            range.style.right = 100 - (maxPrice / rangeInput[1].max) * 100 + "%";
                        }
                    }
                });
            });

            rangeInput.forEach(input => {
                input.addEventListener("input", e => {
                    let minVal = parseInt(rangeInput[0].value),
                    maxVal = parseInt(rangeInput[1].value);

                    if ((maxVal - minVal) < priceGap) {
                        if (e.target.className === "range-min") {
                            rangeInput[0].value = maxVal - priceGap
                        } else {
                            rangeInput[1].value = minVal + priceGap;
                        }
                    } else {
                        priceInput[0].innerHTML = minVal;
                        priceInput[1].innerHTML = maxVal;
                        range.style.left = ((minVal / rangeInput[0].max) * 100) + "%";
                        range.style.right = 100 - (maxVal / rangeInput[1].max) * 100 + "%";
                        minFilterInput.value = minVal;
                        maxFilterInput.value = maxVal;
                    }
                });
            });
        }
    }

    let custom_filters = document.querySelectorAll(".custom-filter")

    custom_filters.forEach((el)=>{

        let control = el.querySelector(".filter-heading")
        let body = el.querySelector(".filter-body")

        if(control && body){
            control.addEventListener('click', () => {
                if(el.classList.contains("open")){
                    el.classList.remove("open")
                } else {
                    custom_filters.forEach((el)=>{
                        el.classList.remove("open")
                    })
                    el.classList.add("open");
                }
            })
        }
    })

    document.body.addEventListener('click', (e) => {
        if(!e.target.closest(".custom-filter")){
            custom_filters.forEach((el)=>{
                el.classList.remove("open")
            })
        }
    });

    let mobile_control = document.querySelector(".mobile-filter-heading")
    let filter_body = document.querySelector(".custom-filter-wrapper")

    if(mobile_control && filter_body){
        mobile_control.addEventListener('click', () => {
            console.log("CLICK")
            // rotate svg
            if(mobile_control.classList.contains("open")){
                mobile_control.classList.remove("open")
            } else {
                mobile_control.classList.add("open")
            }

            // open filters
            if(filter_body.classList.contains("open")){
                filter_body.classList.remove("open")
            } else {
                filter_body.classList.add("open")
            }
        })
    }

    // const reset_filters = document.querySelector('.reset-filter-wrapper');
    const selected_filters_html = document.querySelectorAll('.selected-filter-wrapper *');

    selected_filters_html.forEach(selected => {
        selected.addEventListener('click', () => {
            collection_grid.classList.add("loading")
        })
    })

    // Submit form on input change or button click on mobile
    const filter_inputs = document.querySelectorAll('.filter-container-wrapper select, .filter-container-wrapper input');
    const filter_form = document.querySelector('.filter-container');
    const reset_filter = document.querySelector('#reset-filters');
    const collection_grid = document.querySelector('.collection-grid');
    const apply_filters_btn = document.querySelector('.apply-filters');

    const isMobile = () => window.innerWidth < 768;

    if (apply_filters_btn) {
        apply_filters_btn.addEventListener('click', () => {
            collection_grid.classList.add("loading");
            filter_form.submit();
        });
    }

    filter_inputs.forEach(input => {
        input.addEventListener('change', () => {
            if (!isMobile()) {
                collection_grid.classList.add("loading");
                filter_form.submit();
            }
        });
    });

    if (reset_filter) {
        reset_filter.addEventListener('click', () => {
            collection_grid.classList.add("loading");
        });
    }

    // Initialize Swiper on page load
    initializeProductCardSwipers();

    setTimeout(function() {
        initRatingSnippet();
    }, 1000); // Adjust the delay time as needed
})

// Function to initialize Swiper on product cards
function initializeProductCardSwipers() {
    // Select all product card Swiper containers
    const productSwipers = document.querySelectorAll('.productCardSwiper');

    productSwipers.forEach((swiperEl) => {
        if (swiperEl.classList.contains('swiper-initialized')) return; // Prevent duplicate initialization

        if (swiperEl.querySelectorAll('.swiper-slide').length <= 1) {
            swiperEl.classList.add('swiper-initialized');
            return; // Nothing to swipe between - skip instantiating a whole carousel
        }

        new window.swiper(swiperEl, {
            loop: true,
            slidesPerView: 1,
            spaceBetween: 0,
            nested: true,
            navigation: {
                nextEl: swiperEl.querySelector('.productCardSwiper-next'),
                prevEl: swiperEl.querySelector('.productCardSwiper-prev'),
            },
            lazy: true, // Enable lazy loading
            preloadImages: false,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });

        swiperEl.classList.add('swiper-initialized'); // Mark as initialized
    });
}

// Function to initialize Reviews.io snippet
function initRatingSnippet() {
    ratingSnippet("ruk_rating_snippet", {
        store: "kettler",
        color: "#B59D6C",
        linebreak: true,
        usePolaris: true,
        text: "Reviews"
    });
}